import {
	Chat20Regular,
	Voicemail20Regular,
	Call20Regular,
	Mail20Regular,
	ArrowDownLeft20Regular,
	ArrowUpRight20Regular,
	Clock20Regular,
	CallTransfer20Regular,
	ChatMultiple20Regular
} from "@fluentui/react-icons";
import {
	HistoryInteractionHandlingFilters,
	HistoryInteractionMiscellaneousFilters,
} from "./types";
import { Callback18Regular, WhatsApp20Regular } from "@/common/icons";
import { tokens } from "@fluentui/react-components";
import { Handled15Regular } from "@/common/icons/handledIcon/handledIcon";
import { Unhandled15Regular } from "@/common/icons/unhandledIcon/unhandledIcon";
import { HistoryInteractionTypes } from "@/repository/models/history";

export const historyInteractionsIconMapMedium = {
	[HistoryInteractionTypes.Call]: <Call20Regular />,
	[HistoryInteractionTypes.Callback]: <Callback18Regular />,
	[HistoryInteractionTypes.Voicemail]: <Voicemail20Regular />,
	[HistoryInteractionTypes.Generic]: <Chat20Regular />,
	[HistoryInteractionTypes.Email]: <Mail20Regular />,
	[HistoryInteractionTypes.WhatsApp]: <WhatsApp20Regular />,
	[HistoryInteractionTypes.Webchat]: <ChatMultiple20Regular />,
};

export const historyInteractionsHandlingFiltersIconMap = {
	[HistoryInteractionHandlingFilters.Handled]: (
		<Handled15Regular strokeColor={tokens.colorNeutralForeground2Link} />
	),
	[HistoryInteractionHandlingFilters.NotHandled]: (
		<Unhandled15Regular strokeColor={tokens.colorNeutralForeground2Link} />
	),
};

export const historyInteractionsMiscelleanousFiltersIconMap = {
	[HistoryInteractionMiscellaneousFilters.Inbound]: <ArrowDownLeft20Regular />,
	[HistoryInteractionMiscellaneousFilters.Outbound]: <ArrowUpRight20Regular />,
	[HistoryInteractionMiscellaneousFilters.Missed]: <Clock20Regular />,
	[HistoryInteractionMiscellaneousFilters.Transferred]: (
		<CallTransfer20Regular />
	),
};
